// extracted by mini-css-extract-plugin
export default {"nav":"IconButton_nav__XBcp9","img":"IconButton_img__LkZBx"};